import { render, staticRenderFns } from "./Display3D.vue?vue&type=template&id=074ccf11&scoped=true&"
import script from "./Display3D.vue?vue&type=script&lang=js&"
export * from "./Display3D.vue?vue&type=script&lang=js&"
import style0 from "./Display3D.vue?vue&type=style&index=0&id=074ccf11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ccf11",
  null
  
)

export default component.exports